import 'react-dates/initialize';
import React, { useState, useRef, useMemo } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import { closeModal } from 'src/actions/modals';
import { withCurrentUser } from 'src/components/withCurrentUser';
import ModalContainer from '../modalContainer';
import { PrimaryButton } from 'src/components/button';
import { modalStyles } from '../styles';
import { TextArea, Error as ErrorElement, Input } from '../../formElements';
import { addToastWithTimeout } from 'src/actions/toasts';
import SelectGroup from 'src/components/selectGroup';
import getPresignedPutUrl from 'src/helpers/uploadFile';
import Icon from 'src/components/icon';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {
  Form,
  Actions,
  EventRadio,
  Label,
  Option,
  PostOptionLabel,
  Row,
  RowSection,
  SquareButton,
  GreyText,
  Section,
  PreviewMedia,
  RemovePreviewButton,
  PreviewVideo,
  VideoName,
  VideoInfoRightContainer,
  InputLabel,
  YoutubeInput,
  TextOnLoading,
  StyledDiv,
  BlockDiv,
} from './style';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';
import moment from 'moment';
import dataProvider from 'shared/rest';
import MediaUploader from 'src/components/mediaUploader';
import 'react-select-search/style.css';
import './override.css';
import { REGEXPS } from 'shared/draft-utils/add-embeds-to-draft-js';
import { Roles_Display } from '../../../utils';
import AsyncSelect from 'react-select/async';

const { youtube } = REGEXPS;

const eventModalTitle = {
  DEFAULT: 'Create an event',
  PAST: 'Create a past event',
};

export const EVENT_CREATE_STATUS = Object.freeze({
  PAST: 'PAST',
  DEFAULT: 'DEFAULT',
});

export const EVENT_CREATE_STATUS_ENUM = [
  EVENT_CREATE_STATUS.PAST,
  EVENT_CREATE_STATUS.DEFAULT,
];

const rolesAllowdToCreatePastEvent = ['SUPER_ADMIN', 'COMMUNITY_ADMIN'];

const DATA_TEST_PRE = 'create-event-modal-';

function debounce(func, timeout = 500) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

function DebounceSelect({ fetchOptions, debounceTimeout = 8000, ...props }) {
  const [fetching, setFetching] = useState(false);
  const fetchRef = useRef(0);
  const debounceFetcher = useMemo(() => {
    const loadOptions = value => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setFetching(true);
      fetchOptions(value).then(newOptions => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return;
        }
        setFetching(false);
      });
    };
    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);
  return (
    <AsyncSelect
      isLoading={fetching}
      cacheOptions
      loadOptions={debounceFetcher}
      {...props}
    />
  );
}

const CreateEventModal = props => {
  const { isOpen, dispatch, history, groupId, currentUser } = props;
  const styles = modalStyles(720);
  const currentUserRole = currentUser.role ? currentUser.role.split(',') : [];
  const allowdRole = currentUser.role
    ? rolesAllowdToCreatePastEvent.filter(role =>
        currentUserRole.includes(role)
      )
    : [];
  const [date, setDate] = useState(moment());
  const [focused, setFocused] = useState(false);
  const [loading, setLoading] = useState(false);
  const [createError, setCreateError] = useState(false);
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [description, setDescription] = useState('');
  const [isOnline, setIsOnline] = useState(true);
  const [visibility, setVisibility] = useState('PUBLIC');
  const [startTime, setStartTime] = useState(undefined);
  const [endTime, setEndTime] = useState(undefined);

  const [previewMedia, setPreviewMedia] = useState();
  const [bannerImageFile, setBannerImageFile] = useState();
  const [moderator, setModerator] = useState(null);
  const [eventTimeError, setEventTimeError] = useState();
  const [nameError, setNameError] = useState();
  const [descriptionError, setDescriptionError] = useState();
  const [bannerImageError, setBannerImageError] = useState();
  const [selectGroupId, setSelectGroupId] = useState();
  const [groupError, setGroupError] = useState();
  const [selectGroup, setSelectGroup] = useState();
  const [youtubeLink, setYoutubeLink] = useState();
  const [youtubeLinkError, setYoutubeLinkError] = useState();
  const [videoError, setVideoError] = useState();
  const [pastEventVideoFile, setPastEventVideoFile] = useState();
  const [createEventType, setCreateEventType] = useState(
    EVENT_CREATE_STATUS.DEFAULT
  );

  const onSelectFile = file => {
    if (file.size > 3000000) {
      setBannerImageError('Photo uploads should be less than 3mb');
      return;
    } else {
      setBannerImageError();
    }
    setPreviewMedia(window.URL.createObjectURL(file));
    setBannerImageFile(file);
  };
  const onSelectVideo = file => {
    if (file.type !== 'video/mp4') {
      setVideoError('Please upload a mp4 file!');
      return;
    }
    if (file.size > 250000000) {
      // 设置视频文件的最大值
      setVideoError('Video uploads should be less than 250mb');
      return;
    } else {
      setVideoError();
    }
    setPastEventVideoFile(file);
  };

  const onYoutuLinkChange = value => {
    if (!value) {
      setYoutubeLink('');
      return;
    }
    value.match(youtube)
      ? (function() {
          setYoutubeLinkError('');
          // remove the params after '&'
          setYoutubeLink(value.split('&')[0]);
        })()
      : setYoutubeLinkError('Please input a Youtube link');
  };

  const close = () => dispatch(closeModal());
  const create = async e => {
    e.preventDefault();
    if (
      !name ||
      name.length > 250 ||
      !description ||
      !startTime ||
      !endTime ||
      !bannerImageFile ||
      !(groupId || selectGroupId) ||
      (createEventType === EVENT_CREATE_STATUS.PAST &&
        !youtubeLink &&
        !pastEventVideoFile) ||
      !date ||
      !moment(date).isValid()
    ) {
      if (!name) {
        setNameError('required');
      }
      if (name.length > 250) {
        setNameError('cannot be longer than 250 characters');
      }
      if (!description) {
        setDescriptionError('required');
      }
      if (!startTime || !endTime) {
        setEventTimeError('required');
      }
      if (!date || !moment(date).isValid()) {
        setEventTimeError('invalid date');
      }
      if (!bannerImageFile) {
        setBannerImageError('Please add an event banner image.');
      }
      if (!(groupId || selectGroupId)) {
        setGroupError('Please choose a community group.');
      }
      if (!youtubeLink && !pastEventVideoFile) {
        setYoutubeLinkError(
          'Please enter a Youtube link or upload a video before creating a past event.'
        );
      }
      setCreateError(true);
      setLoading(false);
      return;
    } else {
      setNameError('');
      setDescriptionError('');
      setEventTimeError('');
      setBannerImageError('');
      setGroupError('');
      setYoutubeLinkError('');
      setCreateError(false);
    }

    if (loading) {
      return;
    }

    setLoading(true);
    const start = moment({
      year: date.year(),
      month: date.month(),
      day: date.date(),
      hour: startTime.hour(),
      minute: startTime.minute(),
    }).toISOString();
    const end = moment({
      year: date.year(),
      month: date.month(),
      day: date.date(),
      hour: endTime.hour(),
      minute: endTime.minute(),
    }).toISOString();

    if (moment(start).isSameOrAfter(moment(end))) {
      setEventTimeError('start time should be early than end time');
      setLoading(false);
      return;
    }
    if (
      createEventType === EVENT_CREATE_STATUS.DEFAULT &&
      moment(start).isBefore(moment())
    ) {
      setEventTimeError('Cannot create event in the past');
      setLoading(false);
      return;
    }
    let bannerImage;
    if (bannerImageFile) {
      bannerImage = await getPresignedPutUrl({
        location: 'post',
        file: bannerImageFile,
      });
    }
    let uploadLink = youtubeLink;
    if (pastEventVideoFile) {
      uploadLink = await getPresignedPutUrl({
        location: 'event/past',
        file: pastEventVideoFile,
      });
    }

    let params = {
      start,
      end,
      name,
      description,
      address,
      visibility,
      isOnline,
      groupId: groupId ? groupId : selectGroupId,
      bannerImage,
      moderatorId: moderator ? moderator.value : undefined,
      userId: currentUser.id,
      uploadLink,
    };
    if (createEventType === EVENT_CREATE_STATUS.PAST) {
      params = { ...params, moderatorId: undefined };
    }
    const result = (await dataProvider.invoke('events', 'createEvent', params))
      .data;

    if (result.ok) {
      // FIXME: here
      props.dispatch(addToastWithTimeout('success', 'Created A New Event'));
      setName('');
      setDescription('');
      setIsOnline(false);
      setVisibility('PUBLIC');
      props.dispatch(closeModal());
      if (window.Appcues) {
        window.Appcues.track(`added_event`);
      }
      setLoading(false);
      history.push(
        `/${result.publishedEvent.group.slug}/event/${result.publishedEvent.id}`
      );
    } else {
      setLoading(false);
      props.dispatch(
        addToastWithTimeout(
          'error',
          result.message || 'Create event failed',
          10000
        )
      );
      props.dispatch(closeModal());
    }
  };

  async function fetchUserList(username) {
    const result = await dataProvider.invoke('events', 'getMockModUserList', {
      userId: currentUser.id,
      name: username,
    });
    return result.data.map(u => ({
      user: u,
      label: `${u.name} | ${Roles_Display[u.primaryRole]}`,
      value: u.id,
    }));
  }

  let commonPropsForDatePicker = {
    date,
    onDateChange: d => setDate(d),
    focused,
    onFocusChange: ({ focused }) => setFocused(focused),
    block: true,
    small: true,
    numberOfMonths: 1,
    displayFormat: 'D MMM YYYY',
    id: 'your_unique_id',
    hideKeyboardShortcutsPanel: true,
    inputIconPosition: 'after',
  };
  if (createEventType === EVENT_CREATE_STATUS.PAST) {
    commonPropsForDatePicker = {
      isOutsideRange: () => false,
      ...commonPropsForDatePicker,
      isDayBlocked: date => {
        return date.isSameOrAfter(new moment());
      },
    };
  }

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={close}
      shouldCloseOnOverlayClick={true}
      style={styles}
      closeTimeoutMS={330}
    >
      <ModalContainer
        title={eventModalTitle[createEventType]}
        closeModal={close}
      >
        <Form>
          {allowdRole.length > 0 && (
            <Row>
              <Section>
                <Label>Event type</Label>
                <EventRadio>
                  <Option selected={true}>
                    <PostOptionLabel>
                      <input
                        data-testid={`${DATA_TEST_PRE}radio-Upcoming`}
                        type="radio"
                        value="Upcoming"
                        name="createEventType"
                        defaultChecked
                        onClick={() =>
                          setCreateEventType(EVENT_CREATE_STATUS.DEFAULT)
                        }
                      />
                      Upcoming
                    </PostOptionLabel>
                  </Option>
                  <Option>
                    <PostOptionLabel selected={false}>
                      <input
                        data-testid={`${DATA_TEST_PRE}radio-Past`}
                        type="radio"
                        value="Past"
                        name="createEventType"
                        onClick={() =>
                          setCreateEventType(EVENT_CREATE_STATUS.PAST)
                        }
                      />
                      Past
                    </PostOptionLabel>
                  </Option>
                </EventRadio>
              </Section>
            </Row>
          )}
          <TextArea
            testId={`${DATA_TEST_PRE}TextArea-Name`}
            id="name"
            placeholder="What's this event name?"
            onChange={e => setName(e.target.value)}
          >
            Name
          </TextArea>
          <ErrorElement>{nameError}</ErrorElement>
          <TextArea
            testId={`${DATA_TEST_PRE}TextArea-description`}
            id="description"
            placeholder="Tell the audience more about the events to attract their attention."
            onChange={e => setDescription(e.target.value)}
          >
            Description
          </TextArea>
          <ErrorElement>{descriptionError}</ErrorElement>
          <Row>
            <Section>
              <Label>Date</Label>
            </Section>
            <Section>
              <Label>Time</Label>
            </Section>
          </Row>
          <Row>
            <Section>
              <StyledDiv data-testid={`${DATA_TEST_PRE}SingleDatePicker`}>
                <SingleDatePicker
                  {...commonPropsForDatePicker}
                  customInputIcon={<KeyboardArrowDownIcon />}
                />
              </StyledDiv>
            </Section>
            <RowSection>
              <StyledDiv data-testid={`${DATA_TEST_PRE}TimePicker-start`}>
                <TimePicker
                  focusOnOpen
                  showSecond={false}
                  value={startTime}
                  minuteStep={15}
                  placeholder="Start"
                  getPopupContainer={triggerNode => triggerNode.parentNode}
                  onChange={v => {
                    setStartTime(v);
                    if (!endTime || endTime.isSameOrBefore(v)) {
                      setEndTime(v.clone().add(15, 'minute'));
                    }
                  }}
                />
              </StyledDiv>
              <StyledDiv data-testid={`${DATA_TEST_PRE}TimePicker-End`}>
                <TimePicker
                  focusOnOpen
                  showSecond={false}
                  value={endTime}
                  minuteStep={15}
                  placeholder="End"
                  getPopupContainer={triggerNode => triggerNode.parentNode}
                  onChange={v => {
                    setEndTime(v);
                    if (!startTime || startTime.isSameOrAfter(v)) {
                      setStartTime(v.clone().subtract(15, 'minute'));
                    }
                  }}
                />
              </StyledDiv>
            </RowSection>
          </Row>
          <ErrorElement>{eventTimeError}</ErrorElement>
          {isOnline && createEventType === EVENT_CREATE_STATUS.DEFAULT && (
            <React.Fragment>
              <Label>Event Moderator</Label>
              <BlockDiv data-testid={`${DATA_TEST_PRE}SelectSearch`}>
                <DebounceSelect
                  value={moderator}
                  placeholder="Select a moderator, type to search"
                  loadOptions={fetchUserList}
                  onChange={value => {
                    setModerator(value);
                  }}
                />
              </BlockDiv>
            </React.Fragment>
          )}
          {createEventType === EVENT_CREATE_STATUS.DEFAULT && (
            <React.Fragment>
              <Row className="event-type">
                <Section>
                  <Label>Event type</Label>
                  <EventRadio>
                    <Option selected={false}>
                      {currentUser.role &&
                        !currentUser.role.includes('STUDENT') && (
                          <PostOptionLabel>
                            <input
                              data-testid={`${DATA_TEST_PRE}offline`}
                              type="radio"
                              value="offline"
                              name="is-online"
                              onClick={() => setIsOnline(false)}
                            />
                            offline
                          </PostOptionLabel>
                        )}
                    </Option>
                    <Option selected={true}>
                      <PostOptionLabel>
                        <input
                          data-testid={`${DATA_TEST_PRE}online`}
                          type="radio"
                          value="online"
                          name="is-online"
                          defaultChecked
                          onClick={() => setIsOnline(true)}
                        />
                        online
                      </PostOptionLabel>
                    </Option>
                  </EventRadio>
                </Section>
                <Section>
                  <Label>Privacy</Label>
                  <EventRadio>
                    <Option selected={true}>
                      <PostOptionLabel>
                        <input
                          data-testid={`${DATA_TEST_PRE}public`}
                          type="radio"
                          value="public"
                          name="visibility"
                          onClick={() => setVisibility('PUBLIC')}
                          defaultChecked
                        />
                        public
                      </PostOptionLabel>
                    </Option>
                    <Option selected={false}>
                      <PostOptionLabel>
                        <input
                          data-testid={`${DATA_TEST_PRE}private`}
                          type="radio"
                          value="private"
                          name="visibility"
                          onClick={() => setVisibility('PRIVATE')}
                        />
                        private
                      </PostOptionLabel>
                    </Option>
                  </EventRadio>
                </Section>
              </Row>
              <React.Fragment>
                {isOnline ? (
                  <React.Fragment>
                    <Label>Event link</Label>
                    <Row>
                      <GreyText>
                        A Zoom link will be generated once the event is
                        published.
                      </GreyText>
                    </Row>
                  </React.Fragment>
                ) : (
                  <Input
                    testId={`${DATA_TEST_PRE}address`}
                    id="address"
                    placeholder="Address"
                    onChange={e => setAddress(e.target.value)}
                  >
                    Location
                  </Input>
                )}
              </React.Fragment>
            </React.Fragment>
          )}
          {props.groupId ? null : (
            <div>
              <Label>Select a group</Label>
              <BlockDiv data-testid={`${DATA_TEST_PRE}selectGroup`}>
                <SelectGroup
                  currentUser={props.currentUser}
                  chooseGroup={v => {
                    setSelectGroupId(v.value);
                    setGroupError('');
                    setSelectGroup(v);
                  }}
                  groupId={selectGroupId}
                  selectGroup={selectGroup}
                />
              </BlockDiv>
              <ErrorElement>{groupError}</ErrorElement>
            </div>
          )}
          <Label>Banner image</Label>
          {previewMedia && (
            <PreviewMedia>
              <img src={previewMedia} alt="" />
              <RemovePreviewButton onClick={() => setPreviewMedia()}>
                <Icon
                  data-testid={`${DATA_TEST_PRE}banner-image-close`}
                  glyph="view-close-small"
                  size={'16'}
                />
              </RemovePreviewButton>
            </PreviewMedia>
          )}
          {!previewMedia && (
            <SquareButton
              data-testid={`${DATA_TEST_PRE}upload-banner`}
              type="button"
            >
              <MediaUploader
                icon="add"
                color="#fff"
                size={42}
                isSendingMediaMessage={false}
                tooltipContent="Upload photo"
                onValidated={onSelectFile}
                currentUser={props.currentUser}
                onError={err => setBannerImageError(err)}
                accept={'.png, .jpg, .jpeg, .gif'}
              />
            </SquareButton>
          )}
          <ErrorElement>{bannerImageError}</ErrorElement>
          {createEventType === EVENT_CREATE_STATUS.PAST && (
            <div>
              {!pastEventVideoFile && (
                <InputLabel>
                  Youtube link
                  <span>
                    (You can either have a YouTube link or upload a video）
                  </span>
                </InputLabel>
              )}
              {!pastEventVideoFile && (
                <div>
                  <YoutubeInput
                    testId={`${DATA_TEST_PRE}youtubeLink-input`}
                    id="youtubeLink"
                    placeholder="Youtube Link"
                    onChange={e => onYoutuLinkChange(e.target.value)}
                  ></YoutubeInput>
                  <ErrorElement>{youtubeLinkError}</ErrorElement>
                </div>
              )}
              {createEventType === EVENT_CREATE_STATUS.PAST && !youtubeLink && (
                <Label>Upload a video</Label>
              )}
              {!pastEventVideoFile && !youtubeLink && (
                <React.Fragment>
                  <SquareButton
                    type="button"
                    data-testid={`${DATA_TEST_PRE}upload-video`}
                  >
                    <MediaUploader
                      icon="add"
                      color="#fff"
                      size={42}
                      isSendingMediaMessage={false}
                      tooltipContent="Upload video"
                      accept={'.mp4'}
                      onValidated={onSelectVideo}
                      currentUser={props.currentUser}
                      onError={err => setVideoError(err)}
                      fileName={
                        pastEventVideoFile ? pastEventVideoFile.name : ''
                      }
                    />
                  </SquareButton>
                </React.Fragment>
              )}
              {pastEventVideoFile && (
                <PreviewVideo>
                  <Icon glyph="upload-file" size={'36'} color={'#73747d'} />
                  <VideoInfoRightContainer>
                    <VideoName>{pastEventVideoFile.name}</VideoName>
                    <Icon
                      glyph="view-close-small"
                      onClick={() => {
                        setPastEventVideoFile();
                      }}
                      size={'24'}
                    />
                  </VideoInfoRightContainer>
                </PreviewVideo>
              )}
              <ErrorElement>{videoError}</ErrorElement>
            </div>
          )}
          <Actions>
            <PrimaryButton
              disabled={false}
              onClick={create}
              data-testid={`${DATA_TEST_PRE}create-event`}
            >
              {loading ? 'Creating...' : 'CREATE'}
            </PrimaryButton>
            {loading && (
              <TextOnLoading>
                It may take 1-2 mins to upload the file, please don’t close the
                window.
              </TextOnLoading>
            )}
          </Actions>
          {createError && (
            <ErrorElement>
              Please fix any errors above before creating this event.
            </ErrorElement>
          )}
        </Form>
      </ModalContainer>
    </Modal>
  );
};

const map = state => ({
  isOpen: state.modals.isOpen,
});

export default compose(
  // $FlowIssue
  connect(map),
  withCurrentUser,
  withRouter
)(CreateEventModal);
